<template>
  <div>
    <span
      style="margin-left: 1.5em; margin-right: 3em; fontsize: 14px; margin-bottom: 1em"
      class="has-text-grey"
      >{{ setting.label || name }}
    </span>

    <el-cascader
      v-model="value[name]"
      :options="setting.options"
      :props="setting.props"
      :collapse-tags="setting['collapse-tags']"
      :clearable="setting.clearable"
    >
      <template slot-scope="{ node, data }">
        <span>{{ data.label }}</span>
        <span
          class="has-text-grey"
          :style="{
            float: 'right',
            fontSize: 13 + 'px',
            marginLeft: '1.5em',
          }"
        >
          {{ data.value ? data.value : data.label }}
        </span>
      </template>
    </el-cascader>

    <Tooltip :label="setting.label || name" :content="setting.detail" />s
  </div>
</template>

<script>
/**
 * Cascader SmartField - Renders a cascading selection dropdown for hierarchical data.
 *
 * @component
 * @description Displays a cascading dropdown for selecting hierarchical/nested options.
 * Supports custom props configuration, collapsible tags, and clearable selection.
 * Each option displays both label and value in the dropdown panel.
 *
 * @prop {Object} value - Parent object containing the setting value
 * @prop {Object} setting - Field configuration object
 * @prop {string} [setting.label] - Display label for the cascader (defaults to name)
 * @prop {string} [setting.detail] - Tooltip text explaining the setting
 * @prop {Array<Object>} setting.options - Hierarchical array of options
 * @prop {string} setting.options[].label - Display label for the option
 * @prop {string} setting.options[].value - Value for the option
 * @prop {Array<Object>} [setting.options[].children] - Nested child options
 * @prop {Object} [setting.props] - Cascader configuration (e.g., multiple, checkStrictly)
 * @prop {boolean} [setting['collapse-tags']] - If true, collapses selected tags
 * @prop {boolean} [setting.clearable] - If true, allows clearing the selection
 * @prop {*} [setting.default] - Default value if not set
 * @prop {string} name - Property key in the value object
 *
 * @example
 * <Cascader
 *   :value="config"
 *   :setting="{
 *     label: 'Region',
 *     options: [
 *       { label: 'Asia', value: 'asia', children: [
 *         { label: 'Singapore', value: 'sg' },
 *         { label: 'Malaysia', value: 'my' }
 *       ]}
 *     ],
 *     clearable: true
 *   }"
 *   name="region"
 * />
 */
import Tooltip from "../Tooltip.vue";
export default {
  components: { Tooltip },
  props: ["value", "setting", "name"],
  mounted() {
    if (this.value[this.name] == null) {
      if (this.setting.default != null) {
        this.$set(this.value, this.name, this.setting.default);
      } else {
        this.$set(this.value, this.name, null);
      }
    }
  },
};
</script>
